import React from 'react'
import { string, node, oneOfType, func } from 'prop-types'
import { css } from '@emotion/react'

import Badge from '@/components/Badge'

const badgeCss = (color) => css`
  margin-right: 8px;
  margin-bottom: 2px;
  background: ${color};
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    vertical-align: sub;
    margin-right: 0.25rem;
  }
`

const ProductBadge = ({ label, color, icon: Icon, className = '' }) => (
  <Badge css={badgeCss(color)} className={`product-badge ${className}`}>
    {Icon && <Icon />}
    {label}
  </Badge>
)

ProductBadge.propTypes = {
  label: string,
  color: string,
  icon: oneOfType([func, node]),
  className: string,
}

export default ProductBadge
